/* eslint-disable max-len */
import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export const CalendarIcon = (props: IconProps) => (
  <div>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.33398V2.66732M4 1.33398V2.66732"
        stroke="#2F2F34"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99766 8.66602H8.00364M7.99766 11.3327H8.00364M10.6613 8.66602H10.6673M5.33398 8.66602H5.33997M5.33398 11.3327H5.33997"
        stroke="#2F2F34"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.33398 5.33398H13.6673"
        stroke="#2F2F34"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.66602 8.16216C1.66602 5.25729 1.66602 3.80486 2.50076 2.90243C3.33551 2 4.67901 2 7.36602 2H8.63268C11.3197 2 12.6632 2 13.4979 2.90243C14.3327 3.80486 14.3327 5.25729 14.3327 8.16216V8.5045C14.3327 11.4094 14.3327 12.8618 13.4979 13.7642C12.6632 14.6667 11.3197 14.6667 8.63268 14.6667H7.36602C4.67901 14.6667 3.33551 14.6667 2.50076 13.7642C1.66602 12.8618 1.66602 11.4094 1.66602 8.5045V8.16216Z"
        stroke="#2F2F34"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 5.33398H14"
        stroke="#2F2F34"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
);
